import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "chat-input" }
const _hoisted_2 = { class: "chat-relative" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_InputFiles = _resolveComponent("InputFiles")
  const _component_InputText = _resolveComponent("InputText")
  const _component_InputControls = _resolveComponent("InputControls")
  const _component_Footnote = _resolveComponent("Footnote")
  const _directive_resize = _resolveDirective("resize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        ref: "absolute",
        class: _normalizeClass(["chat-absolute", {fade: $props.fade}])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["container-block", {focused: $data.focused, disabled: $props.disabled, generating: $props.generating, shadow: $props.shadow, recording: $data.recording}]),
          onClick: _cache[5] || (_cache[5] = (...args) => ($options.focus && $options.focus(...args)))
        }, [
          ($props.controls && $options.uploads_enabled)
            ? (_openBlock(), _createBlock(_component_InputFiles, {
                key: 0,
                ref: "uploads",
                "files-store": $data.f_store
              }, null, 8 /* PROPS */, ["files-store"]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_InputText, {
            ref: "input",
            modelValue: _ctx.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
            class: "input-block",
            disabled: $props.disabled || $data.recording,
            placeholder: $props.placeholder,
            description: $props.description,
            generating: $props.generating,
            controls: $props.controls,
            "can-push": $options.can_push,
            onPush: $options.onPush,
            onFocusin: _cache[1] || (_cache[1] = $event => ($data.focused = true)),
            onFocusout: _cache[2] || (_cache[2] = $event => ($data.focused = false)),
            onStop: $options.onStop
          }, null, 8 /* PROPS */, ["modelValue", "disabled", "placeholder", "description", "generating", "controls", "can-push", "onPush", "onStop"]),
          ($props.controls)
            ? (_openBlock(), _createBlock(_component_InputControls, {
                key: 1,
                "can-upload": $options.can_upload,
                recording: $data.recording,
                generating: $props.generating,
                "can-push": $options.can_push,
                "uploads-enabled": $options.uploads_enabled,
                onPush: $options.onPush,
                onStop: $options.onStop,
                onUpload: $options.uploadFile,
                onPrompt: _cache[3] || (_cache[3] = $event => (_ctx.value = $event)),
                onTranscribed: _cache[4] || (_cache[4] = $event => (_ctx.value = $event))
              }, null, 8 /* PROPS */, ["can-upload", "recording", "generating", "can-push", "uploads-enabled", "onPush", "onStop", "onUpload"]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        _createVNode(_component_Footnote, {
          disabled: $props.disabled || $props.generating,
          class: "footer",
          type: "default"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.description), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled"])
      ], 2 /* CLASS */)), [
        [_directive_resize, $options.setHeight]
      ])
    ])
  ]))
}